import C from '@/utils/constant'
import Vue from 'vue'

const form_data = {
    category_id: 0,
    category: {},
    quantity: 1,
    mtm_type: 0,
    part_list: {},
    part_code: [],
    deep_list: {},
    deep_code: [],
    pj_buwei_list: {},
    tj_buwei_list: [],
    zs_buwei_list: [],
    zs_fabric_key: '',
    zs_fabric_material: {},
    zs_fabric_color: {},
    pj_fabric_key: '',
    pj_fabric_material: {},
    pj_fabric_color: {},
    fl_fabric_key: '',
    fl_fabric_material: {},
    fl_fabric_color: {},
    fl2_fabric_key: '',
    fl2_fabric_material: {},
    fl2_fabric_color: {},
    fl3_fabric_key: '',
    fl3_fabric_material: {},
    fl3_fabric_color: {},
    fl4_fabric_key: '',
    fl4_fabric_material: {},
    fl4_fabric_color: {},
    flower_list: {},
    flower_code: [],
    accessory_list: {},
    accessory_code: [],
    model3d_list: {},
    fabric_list: {
        material: {},
        color: {}
    },
    customize_data: [],
    profile: {
        name: "",
        sex: 1,
        birthday: "",
        mobile: "",
        height: "",
        weight: "",
        image: [],
        remark: ""
    },
    profile_list: [],
    clothes_preference: 1,
    measure_type: 1,
    somatotype: "A",
    net_size: {},
    body_size: {},
    complete_size: {},
    body_feature: {},
    bxtz_size: {},
    bxtz_feature: {},
    txxz_size: {},
    txxz_feature: {},
    address_id: 0,
    store_id: 0,
    template_id: 0,
    remark: "",
    // 团定订单有效
    group: {
        column: [],
        customers: []
    },
    // 标码订单有效
    quantity_list: [],
    customer_wanted: [],
    ref_size: ''
};
const form_data_string = JSON.stringify(form_data)
const m = {
    namespaced: true,
    state: {
        picked_category: {},
        form_data: JSON.parse(form_data_string),
        effect_picture: null
    },
    getters: {},
    mutations: {
        pick(state, payload) {
            state.picked_category = payload.category;
            state.form_data = {
                ...JSON.parse(form_data_string),
                // 重复key会覆盖
                category_id: payload.category.id,
                mtm_type: payload.mtm_type ? payload.mtm_type : 0,
                category:  payload.category
            }
            if (state.form_data.mtm_type == C.MTM_TYPE_SIZE) {
                for (let key in payload.category.size_group_data) {
                    let size_item = payload.category.size_group_data[key]
                    for (let i in size_item.list) {
                        size_item.list[i] = {
                            ...size_item.list[i],
                            quantity: 0,
                            remark: "",
                        }
                    }
                    state.form_data.quantity_list.push(size_item)
                }
            }
            state.effect_picture = null;
        },
        clear_part(state, payload) {
            delete state.form_data.part_list[payload.part_key]
            delete state.form_data.model3d_list[payload.part_key]
            let index = state.form_data.part_code.findIndex(item => {
                return item.part_key === payload.part_key;
            });
            if (index > -1) state.form_data.part_code.splice(index, 1);
        },
        choose_part(state, payload) {
            state.form_data.part_list = {
                ...state.form_data.part_list,
                [payload.part_key]: payload.option_name
            };
            state.form_data.model3d_list = {
                ...state.form_data.model3d_list,
                [payload.part_key]: {
                    option_name: payload.option_name,
                    model_path: payload.model_path
                }
            };
            let index = state.form_data.part_code.findIndex(item => {
                return item.part_key === payload.part_name;
            });
            if (index > -1) state.form_data.part_code.splice(index, 1);
            state.form_data.part_code.push({
                part_key: payload.part_name,
                option_name: payload.option_name,
                cad_code: payload.option_key,
                part_key_cad: payload.part_key,
                no_cad: payload.no_cad
            });
        },
        choose_fabric(state, payload) {
            state.form_data.fabric_list = {
                material: payload.material,
                color: payload.color
            };
        },
        update_customize_data(state, payload) {
            let selected_index = state.form_data.customize_data.findIndex((item) => {
                return item.code === payload.code
            })
            if (selected_index > -1) {
                state.form_data.customize_data.splice(selected_index, 1)
            }
            state.form_data.customize_data.push(payload.data)
        },
        remove_customize_data(state, payload) {
            let selected_index = state.form_data.customize_data.findIndex((item) => {
                return item.code === payload.code
            })
            if (selected_index > -1) {
                state.form_data.customize_data.splice(selected_index, 1)
            }
        },
        reset_customize_data(state) {
            state.form_data.customize_data = []
        },
        update_effect_picture(state, value) {
            state.effect_picture = value;
        },
        update_profile(state, payload) {
            // Vue.set(state.form_data.profile, payload.key, payload.value)
            state.form_data.profile = {
                ...state.form_data.profile,
                [payload.key]: payload.value
            };
        },
        update_clothes_preference(state, value) {
            state.form_data.clothes_preference = value;
        },
        update_somatotype(state, value) {
            state.form_data.somatotype = value;
        },
        update_measure_type(state, value) {
            state.form_data.measure_type = value;
        },
        reset_size(state, payload) {
            state.form_data[payload.type_name] = {};
        },
        update_size(state, payload) {
            state.form_data[payload.type_name] = {
                ...state.form_data[payload.type_name],
                [payload.key]: payload.value
            };
        },
        update_body_feature(state, payload) {
            state.form_data.body_feature = {
                ...state.form_data.body_feature,
                [payload.body]: payload.feature
            };
        },
        update_bxtz_feature(state, payload) {
            state.form_data.bxtz_feature = {
                ...state.form_data.bxtz_feature,
                [payload.key]: payload.feature
            };
            state.form_data.bxtz_size = {
                ...state.form_data.bxtz_size,
                [payload.key]: payload.val
            }
        },
        update_txxz_feature(state, payload) {
            state.form_data.txxz_feature = {
                ...state.form_data.txxz_feature,
                [payload.key]: payload.feature
            };
            state.form_data.txxz_size = {
                ...state.form_data.txxz_size,
                [payload.key]: payload.val
            }
        },
        add_profile_image(state, url) {
            state.form_data.profile.image.push(url);
        },
        clear_profile_image(state) {
            state.form_data.profile.image = Array.of();
        },
        remove_profile_image(state, index) {
            state.form_data.profile.image.splice(index, 1);
        },
        choose_address(state, id) {
            state.form_data.address_id = id;
        },
        choose_template(state, id) {
            state.form_data.template_id = id;
        },
        update_remark(state, content) {
            state.form_data.remark = content;
        },
        update_quantity(state, quantity) {
            state.form_data.quantity = quantity;
        },
        update_group(state, list) {
            state.form_data.group = list;
        },
        update_quantity_list(state, payload) {
            state.form_data.quantity_list[payload.k].list[payload.i][payload.field] = payload.value
            Vue.set(state.form_data.quantity_list, payload.k, state.form_data.quantity_list[payload.k])
        },
        update_mtm_type(state, value) {
            state.form_data.mtm_type = value;
        },
        set_profile_list(state, value) {
            state.form_data.profile_list = value;
        },
        update_common(state, payload) {
            state.form_data[payload.key] = payload.value
        },
        clear_deep(state, payload) {
            delete state.form_data.deep_list[payload.deep_key]
            let index = state.form_data.deep_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) state.form_data.deep_code.splice(index, 1);
        },
        choose_deep(state, payload) {
            state.form_data.deep_list = {
                ...state.form_data.deep_list,
                [payload.deep_key]: payload.option_name
            };
            let index = state.form_data.deep_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) state.form_data.deep_code.splice(index, 1);
            state.form_data.deep_code.push({
                deep_key: payload.deep_key,
                deep_name: payload.deep_name,
                option_name: payload.option_name,
                option_key: payload.option_key,
                color_key: '',
                color_name_cn: '',
                color_value: ''
            });
        },
        choose_deep_color(state, payload) {
            let index = state.form_data.deep_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) {
                let temp = state.form_data.deep_code[index]
                temp.color_key = payload.color_item.color_key
                temp.color_name_cn = payload.color_item.color_name_cn
                temp.color_value = payload.color_item.color_value
                state.form_data.deep_code.splice(index, 1, temp)
            };
        },
        clear_accessory(state, payload) {
            delete state.form_data.accessory_list[payload.deep_key]
            let index = state.form_data.accessory_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) state.form_data.accessory_code.splice(index, 1);
        },
        choose_accessory(state, payload) {
            state.form_data.accessory_list = {
                ...state.form_data.accessory_list,
                [payload.deep_key]: payload.option_name
            };
            let index = state.form_data.accessory_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) state.form_data.accessory_code.splice(index, 1);
            state.form_data.accessory_code.push({
                deep_key: payload.deep_key,
                deep_name: payload.deep_name,
                option_name: payload.option_name,
                option_key: payload.option_key,
                color_key: '',
                color_name_cn: '',
                color_value: ''
            });
        },
        choose_accessory_color(state, payload) {
            let index = state.form_data.accessory_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) {
                let temp = state.form_data.accessory_code[index]
                temp.color_key = payload.color_item.color_key
                temp.color_name_cn = payload.color_item.color_name_cn
                temp.color_value = payload.color_item.color_value
                state.form_data.accessory_code.splice(index, 1, temp)
            };
        },
        clear_flower(state, payload) {
            delete state.form_data.flower_list[payload.deep_key]
            let index = state.form_data.flower_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) state.form_data.flower_code.splice(index, 1);
        },
        choose_flower(state, payload) {
            state.form_data.flower_list = {
                ...state.form_data.flower_list,
                [payload.deep_key]: payload.option_name
            };
            let index = state.form_data.flower_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) state.form_data.flower_code.splice(index, 1);
            state.form_data.flower_code.push({
                deep_key: payload.deep_key,
                deep_name: payload.deep_name,
                option_name: payload.option_name,
                option_key: payload.option_key,
                sku: payload.sku,
            });
        },
        choose_pj(state, payload) {
            let key = payload.key
            let option = payload.option
            if(state.form_data.pj_buwei_list[key]?.text == option.text) {
                Vue.set(state.form_data.pj_buwei_list, key, {})
            } else {
                Vue.set(state.form_data.pj_buwei_list, key, option)
            }
        },
        clear_pj(state, key) {
            if(state.form_data.pj_buwei_list.hasOwnProperty(key)) {
                delete state.form_data.pj_buwei_list[key]
            }
        },
        choose_zs(state, payload) {
            let option = payload.option
            if(state.form_data.zs_buwei_list.map(v=>v.text).includes(option.text)) {
                let idx = state.form_data.zs_buwei_list.findIndex(v=>v.text===option.text)
                state.form_data.zs_buwei_list.splice(idx, 1)
            } else {
                state.form_data.zs_buwei_list.push(option)
            }
        },
        clear_zs(state, text) {
            if(state.form_data.zs_buwei_list.map(v=>v.text).includes(text)) {
                let idx = state.form_data.zs_buwei_list.findIndex(v=>v.text===text)
                state.form_data.zs_buwei_list.splice(idx, 1)
            }
        },
        choose_zs_fabric_key(state, payload) {
            if(state.form_data.zs_fabric_key === payload.key) {
                state.form_data.zs_fabric_key = ''
                state.form_data.zs_fabric_material = {}
                state.form_data.zs_fabric_color = {}
            } else {
                state.form_data.zs_fabric_key = payload.key
                state.form_data.zs_fabric_material = payload.material
                state.form_data.zs_fabric_color = payload.color
            }
        },
        choose_zs_common_color(state, payload) {
            state.form_data[`zs_fabric_color`] = payload.color_item
            let index = state.form_data.deep_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) {
                let temp = state.form_data.deep_code[index]
                temp.color_key = payload.color_item.color_key
                temp.color_name_cn = payload.color_item.color_name_cn
                temp.color_value = payload.color_item.color_value
                state.form_data.deep_code.splice(index, 1, temp)
            };
        },
        choose_pj_fabric_key(state, payload) {
            if(state.form_data.pj_fabric_key === payload.key) {
                state.form_data.pj_fabric_key = ''
                state.form_data.pj_fabric_material = {}
                state.form_data.pj_fabric_color = {}
            } else {
                state.form_data.pj_fabric_key = payload.key
                state.form_data.pj_fabric_material = payload.material
                state.form_data.pj_fabric_color = payload.color
            }
        },
        choose_pj_common_color(state, payload) {
            state.form_data[`pj_fabric_color`] = payload.color_item
            let index = state.form_data.deep_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) {
                let temp = state.form_data.deep_code[index]
                temp.color_key = payload.color_item.color_key
                temp.color_name_cn = payload.color_item.color_name_cn
                temp.color_value = payload.color_item.color_value
                state.form_data.deep_code.splice(index, 1, temp)
            };
        },
        choose_tj(state, payload) {
            let option = payload.option
            if(state.form_data.tj_buwei_list.map(v=>v.text).includes(option.text)) {
                let idx = state.form_data.tj_buwei_list.findIndex(v=>v.text===option.text)
                state.form_data.tj_buwei_list.splice(idx, 1)
            } else {
                state.form_data.tj_buwei_list.push(option)
            }
        },
        clear_tj(state, text) {
            if(state.form_data.tj_buwei_list.map(v=>v.text).includes(text)) {
                let idx = state.form_data.tj_buwei_list.findIndex(v=>v.text===text)
                state.form_data.tj_buwei_list.splice(idx, 1)
            }
        },
        choose_fl_common_color(state, payload) {
            state.form_data[`${payload.prefix}_fabric_color`] = payload.color_item
            let index = state.form_data.accessory_code.findIndex(item => {
                return item.deep_key === payload.deep_key;
            });
            if (index > -1) {
                let temp = state.form_data.accessory_code[index]
                temp.color_key = payload.color_item.color_key
                temp.color_name_cn = payload.color_item.color_name_cn
                temp.color_value = payload.color_item.color_value
                state.form_data.accessory_code.splice(index, 1, temp)
            };
        },
        choose_fl_fabric_key(state, payload) {
            if(state.form_data.fl_fabric_key === payload.key) {
                state.form_data.fl_fabric_key = ''
                state.form_data.fl_fabric_material = {}
                state.form_data.fl_fabric_color = {}
            } else {
                state.form_data.fl_fabric_key = payload.key
                state.form_data.fl_fabric_material = payload.material
                state.form_data.fl_fabric_color = payload.color
            }
        },
        choose_fl2_fabric_key(state, payload) {
            if(state.form_data.fl2_fabric_key === payload.key) {
                state.form_data.fl2_fabric_key = ''
                state.form_data.fl2_fabric_material = {}
                state.form_data.fl2_fabric_color = {}
            } else {
                state.form_data.fl2_fabric_key = payload.key
                state.form_data.fl2_fabric_material = payload.material
                state.form_data.fl2_fabric_color = payload.color
            }
        },
        choose_fl3_fabric_key(state, payload) {
            if(state.form_data.fl3_fabric_key === payload.key) {
                state.form_data.fl3_fabric_key = ''
                state.form_data.fl3_fabric_material = {}
                state.form_data.fl3_fabric_color = {}
            } else {
                state.form_data.fl3_fabric_key = payload.key
                state.form_data.fl3_fabric_material = payload.material
                state.form_data.fl3_fabric_color = payload.color
            }
        },
        choose_fl4_fabric_key(state, payload) {
            if(state.form_data.fl4_fabric_key === payload.key) {
                state.form_data.fl4_fabric_key = ''
                state.form_data.fl4_fabric_material = {}
                state.form_data.fl4_fabric_color = {}
            } else {
                state.form_data.fl4_fabric_key = payload.key
                state.form_data.fl4_fabric_material = payload.material
                state.form_data.fl4_fabric_color = payload.color
            }
        },
        add_customer_wanted(state, path) {
            state.form_data.customer_wanted.push(path)
        },
        remove_customer_wanted(state, index) {
            state.form_data.customer_wanted.splice(index, 1)
        },
        choose_another(state, payload) {
            let design_mtm = payload.design_mtm
            let design_data = design_mtm.design_data
            state.form_data.part_list = design_data.part_list
            state.form_data.part_code = design_data.part_code_list
            state.form_data.deep_list = design_data.deep_list
            state.form_data.deep_code = design_data.deep_code
            state.form_data.accessory_list = design_data.accessory_list
            state.form_data.accessory_code = design_data.accessory_code
            state.form_data.flower_list = design_data.flower_list
            state.form_data.flower_code = design_data.flower_code
            state.form_data.pj_buwei_list = design_data.pj_buwei_list
            state.form_data.zs_buwei_list = design_data.zs_buwei_list
            state.form_data.tj_buwei_list = design_data.tj_buwei_list
            state.form_data.fabric_list = design_data.fabric_list
        },
        update_category_option(state, payload) {
            Vue.set(state.form_data.category[payload.key][payload.index], 'option_list', payload.option_list)
        },
    },
    actions: {}
};

export default m;
